import { Component, Input, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DataSessionService } from '../../../core/services/data-session.service';
import { ContentItemComponent } from '../content-item/content-item.component';
import { GeneralErrorComponent } from '../../shared/ui/general-error/general-error.component';
import { Content } from '../type/content';
import { UserSessionData } from '../../../core/types/session-data';

@Component({
  selector: 'app-content',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, ContentItemComponent, GeneralErrorComponent],
  providers: [],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
})
export class ContentComponent{
  @Input() managView: boolean = false;
  @Input() contenData!: Content[];
  userData!: UserSessionData | null;

  constructor(private readonly _dataSessionService: DataSessionService
  ) {
    this.userData = this._dataSessionService.userData;
  }

}